import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import debounce from 'lodash/debounce';
import styles from './FlexCarousel.scss';
import Arrow from './Arrow';
import { USER_AGENT_PROP_TYPES } from '../../../shared/model/types';

class FlexCarousel extends Component {
  constructor(props) {
    super(props);
    this.containerRef = React.createRef();
    this.list = React.createRef();
  }

  state = {
    atEnd: false,
    atStart: true,
  }

  static contextTypes = {
    userAgent: USER_AGENT_PROP_TYPES,
  };

  componentDidMount = () => {
    // TODO: [CAROUSELCLEANUP] Calculate atEnd on mount (jest was getting confused with new ref syntax)
    window.addEventListener('resize', debounce(this.reset, 400, { leading: true, trailing: false }));
  }

  reset = () => {
    this.setState({
    }, () => this.containerRef.current.scrollTo(0, 0));
  }

  calculateChildWidth = () => (this.list.current.children ? this.list.current.children[0].getBoundingClientRect().width : 0)

  move = (direction) => {
    const childWidth = this.calculateChildWidth();
    const scrollAmount = direction * this.props.shiftBy * childWidth;
    this.containerRef.current.scrollBy({ left: scrollAmount, top: 0, behavior: 'smooth' });
  }

  updateArrowButtonVisibility = () => {
    const containerElement = this.containerRef.current;
    const visibleWidth = containerElement.getBoundingClientRect().width;
    const totalWidth = containerElement.scrollWidth;
    const scrollAmount = containerElement.scrollLeft;

    const atEnd = totalWidth - visibleWidth - scrollAmount < 2;
    const atStart = scrollAmount === 0;

    if (atEnd !== this.state.atEnd) {
      this.setState({ atEnd });
    }
    if (atStart !== this.state.atStart) {
      this.setState({ atStart });
    }
  }

  render = () => {
    const { isMobile, isTablet, isDesktop } = this.context.userAgent || { isDesktop: true };
    const { children, listClassName, arrowClassName, itemClassName } = this.props;

    return (
      <div className={styles.wrapper}>
        <Arrow
          arrowClassName={arrowClassName}
          onClick={() => this.move(-1)}
          iconName="chevronLeft"
          variant="previous"
          disabled={this.state.atStart}
          isDesktop={isDesktop}
        />
        <div
          id="container"
          ref={this.containerRef}
          onScroll={this.updateArrowButtonVisibility}
          className={
            classNames(
              {
                [styles.trackOnMobile]: isMobile,
                [styles.trackOnTablet]: isTablet,
                [styles.trackOnDesktop]: isDesktop,
              },
            )
          }
        >
          <div ref={this.list} className={listClassName || styles.list}>
            {children.map(child => (
              <div
                className={itemClassName || styles.item}
                key={child.key}
              >{child}
              </div>
            ))}
          </div>
        </div>
        <Arrow
          arrowClassName={arrowClassName}
          onClick={() => this.move(1)}
          iconName="chevronRight"
          variant="next"
          disabled={this.state.atEnd}
          isDesktop={isDesktop}
        />
      </div>
    );
  }
}

FlexCarousel.propTypes = {
  children: PropTypes.node,
  shiftBy: PropTypes.number,
  arrowClassName: PropTypes.string,
  listClassName: PropTypes.string,
  itemClassName: PropTypes.string,
};

export default FlexCarousel;
